import React, { InputHTMLAttributes } from 'react';
import { useField } from 'formik';

import { Slider, StyledInput, Wrapper } from './styles';

interface InputProps {
  name: string;
  checked: boolean;
}

const ToggleSwitch: React.FC<InputProps & InputHTMLAttributes<HTMLInputElement>> = ({
  name,
  checked,
  ...props
}) => {
  const [field, , helpers] = useField<boolean>(name);
  return (
    <Wrapper>
      <StyledInput
        {...props}
        type="checkbox"
        name={field.name}
        checked={checked}
        onChange={(e) => helpers.setValue(e.target.checked)}
        onBlur={field.onBlur}
      />
      <Slider />
    </Wrapper>
  );
};

export default ToggleSwitch;
